import { Redirect, Route } from 'react-router-dom';
import React from 'react';
import { RouteComponentProps, RouteProps } from 'react-router';
import { setJwtToken } from '../utils/jwt';
import { permissions } from '../constants';

export interface PrivateRouteProps extends RouteProps {
    permissions: permissions[];
    userPermissions: string[];
    redirectTo?: string;
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

export function PrivateRoute({
    permissions,
    userPermissions,
    redirectTo,
    component,
    ...rest
}: PrivateRouteProps) {
    function canActivate() {
        if (!permissions) {
            return true;
        }

        return permissions.some((permission: any) =>
            Array.from(userPermissions).includes(permission.toString())
        );
    }

    const access = canActivate();
    if (!access) {
        setJwtToken('');
        localStorage.removeItem('permissions');
        return (
            <Route
                {...rest}
                render={({ location }) => (
                    <Redirect
                        to={{
                            pathname: redirectTo || '/login',
                            state: { from: location },
                        }}
                    />
                )}
            />
        );
    }

    return <Route {...rest} component={component} />;
}
